import { Gamepad2, Globe, Heart, ShieldCheck, Smartphone, Zap } from "lucide-react";
import React, { useEffect } from "react";
import { Link} from "react-router-dom";

const AboutFirst = () => {

 useEffect(() => {
  let aosInstance;

  import("aos").then((AOS) => {
    aosInstance = AOS.default;
    aosInstance.init({
      duration: 500,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
    });
  });

  return () => {
    aosInstance && aosInstance.refreshHard();
  };
}, []);


  return (
    <section
      className="relative bg-gradient-to-b from-[#0b1120] to-[#1a1f35] pb-11 lg:px-8 text-white sm:pt-[130px] pt-[110px]">
      <div className="container mx-auto px-4">
        <h1
          className="text-center text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-semibold mb-6"
          data-aos="none"
        >
          About{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
           Game Zone Hub
          </span>
        </h1>   

        <div className="max-w-4xl mx-auto text-center md:mb-16 mb-11" data-aos="fade-up">
            <p className="text-[16px] md:text-lg text-gray-300 leading-relaxed mb-6">
              Welcome to <span className="text-blue-400 font-semibold">Game Zone Hub</span>, the internet's premier destination to <strong>play free online games</strong>. 
              Founded with a simple mission: to make gaming accessible to everyone, everywhere, without barriers.
            </p>
            <p className="text-[16px] md:text-lg text-gray-400 leading-relaxed">
              We curate a massive collection of high-quality HTML5 <strong>online games</strong> that run smoothly in your browser. 
              Whether you are a fan of high-speed racing, brain-teasing puzzles, or competitive multiplayer action, 
              Game Zone Hub provides a safe and engaging environment for players of all ages. 
              <strong> No downloads, no subscriptions, just click and play free online.</strong>
            </p>
        </div>

        <ul
          className="grid text-center lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-8 md:mt-10 sm:mt-8 mt-6"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          <li data-aos="zoom-in-up" data-aos-delay="100">
            <div className="bg-[#1e293b] p-8 h-full rounded-2xl shadow-lg border border-white/5 hover:border-blue-500/30 hover:scale-105 transition-all duration-300 group">
              <div className="bg-blue-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-500/20 transition">
                 <Gamepad2 className="w-8 h-8 text-blue-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Unlimited Free Play</h3>
              <p className="text-gray-400 text-sm leading-6">
                Access thousands of <strong>free online games</strong> without spending a penny. We believe entertainment should be free. No hidden costs, no premium walls, and no credit cards required.
              </p>
            </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="200">
             <div className="bg-[#1e293b] p-8 h-full rounded-2xl shadow-lg border border-white/5 hover:border-yellow-500/30 hover:scale-105 transition-all duration-300 group">
               <div className="bg-yellow-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-yellow-500/20 transition">
                 <Zap className="w-8 h-8 text-yellow-400" />
              </div>
               <h3 className="text-xl font-bold text-white mb-3">Instant Access Technology</h3>
               <p className="text-gray-400 text-sm leading-6">
                 Powered by advanced HTML5 and WebGL technology, our games load instantly. Say goodbye to long downloads and heavy updates. Just click and <strong>play free online</strong>.
               </p>
             </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="300">
           <div className="bg-[#1e293b] p-8 h-full rounded-2xl shadow-lg border border-white/5 hover:border-green-500/30 hover:scale-105 transition-all duration-300 group">
             <div className="bg-green-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-green-500/20 transition">
                <ShieldCheck className="w-8 h-8 text-green-400" />
             </div>
             <h3 className="text-xl font-bold text-white mb-3">Safe & Secure</h3>
             <p className="text-gray-400 text-sm leading-6">
               Your safety is our priority. We rigorously vet every game to ensure a virus-free experience. Our platform is designed to be family-friendly and secure.
             </p>
           </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="400">
            <div className="bg-[#1e293b] p-8 h-full rounded-2xl shadow-lg border border-white/5 hover:border-purple-500/30 hover:scale-105 transition-all duration-300 group">
              <div className="bg-purple-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-500/20 transition">
                 <Smartphone className="w-8 h-8 text-purple-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Cross-Platform Gaming</h3>
              <p className="text-gray-400 text-sm leading-6">
                Whether you are on a desktop PC, a tablet, or a smartphone (Android & iOS), our responsive interface ensures the best <strong>online games</strong> experience on any screen size.
              </p>
            </div>
          </li>

          <li data-aos="zoom-in-up" data-aos-delay="500">
            <div className="bg-[#1e293b] p-8 h-full rounded-2xl shadow-lg border border-white/5 hover:border-pink-500/30 hover:scale-105 transition-all duration-300 group">
              <div className="bg-pink-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-pink-500/20 transition">
                 <Heart className="w-8 h-8 text-pink-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Curated with Love</h3>
              <p className="text-gray-400 text-sm leading-6">
                We don't just add any game. Our team hand-picks the most engaging and high-quality titles to ensure you always have something amazing to play.
              </p>
            </div>
          </li>

          <li data-aos="zoom-in-up" data-aos-delay="600">
            <div className="bg-[#1e293b] p-8 h-full rounded-2xl shadow-lg border border-white/5 hover:border-cyan-500/30 hover:scale-105 transition-all duration-300 group">
              <div className="bg-cyan-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-cyan-500/20 transition">
                 <Globe className="w-8 h-8 text-cyan-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Global Community</h3>
              <p className="text-gray-400 text-sm leading-6">
                Join millions of gamers from around the world. Compete in leaderboards, share your high scores, and be part of the growing GameZone family.
              </p>
            </div>
          </li>
          
        </ul>
        
        <div className="mt-16 max-w-5xl mx-auto bg-white/5 p-8 rounded-3xl border border-white/10 text-center" data-aos="fade-up">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">Our Vision</h2>
            <p className="text-gray-300 text-lg leading-relaxed">
                "To become the world's most accessible and user-friendly platform for casual gaming, 
                where fun is just a click away, and community comes first."
            </p>
        </div>

        <div
          className="sm:mt-11 mt-8 text-center"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <h3
            className="sm:text-2xl text-xl font-semibold mb-4"
            data-aos="zoom-in"
            data-aos-delay="600"
          >
            Level Up Your Fun Today!
          </h3>
          <Link
            to="/games"
            className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 rounded-full sm:text-lg text-[16px] font-semibold shadow-lg transition"
            data-aos="fade-up"
            data-aos-delay="700"
            aria-label="Play Free Online Games"
          >
            Play Free Online Games
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutFirst;
